/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "ff2b4231c1da64441455cb5c21204db16cf030a6";
